// extracted by mini-css-extract-plugin
export default {"root":"ContainerHead_root__8YZmY"};